import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NoteViewModel } from '../../models/views/note-view.model';

export class NoteHistoryContext {
    constructor(public noteId: number, public notes: NoteViewModel[]) { }
}

@Component({
    selector: 'note-model-history',
    templateUrl: './note-model-history.component.html',
    styles: []
})

export class NoteModelHistoryComponent implements OnInit {
    public notes: NoteViewModel[];

    constructor(public dialogRef: MatDialogRef<NoteModelHistoryComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
        this.notes = data.notes;
    }

    ngOnInit() {
    }
}
